import React from 'react';
import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuth } from '../contexts';
import { useRoute } from '../contexts/RouteContext';
import { canRunStaffActions } from '../utils';
import { DealerCompanyFlag, anyFlagOn } from '../utils/dealerCompanyFlags';

interface DealerFlagRouteProps {
  // Any one of these on the dealer's OWN company lets it in.
  flags: DealerCompanyFlag[];
  children: React.ReactNode;
}

/**
 * A page LHPH staff always see and a dealer sees only when its company has the flag legacy's
 * dealer menu shows it on — Floorplans on FloorplanON, Borrowing Base on BorrowBase, each
 * import on its own flag. (lhphcapital-kdm6)
 *
 * ⚠️ UX, not security — the API scopes the reads to the caller's company and checks the
 * import flag itself (companyAuth.requireCompanyFlag).
 */
const DealerFlagRoute: React.FC<DealerFlagRouteProps> = ({ flags, children }) => {
  const { user } = useAuth();
  const { dealerFlags, dealerFlagsLoaded } = useRoute();

  if (!user) {
    return <Navigate to="/sign-in" replace />;
  }
  if (canRunStaffActions(user)) {
    return <>{children}</>;
  }
  if (!dealerFlagsLoaded) {
    return <Spin style={{ display: 'block', margin: '48px auto' }} />;
  }
  if (!anyFlagOn(dealerFlags, flags)) {
    return <Navigate to="/unauthorized" replace />;
  }
  return <>{children}</>;
};

export default DealerFlagRoute;
